import React from 'react';
import { Container } from './Container';
import { SectionHeading } from './SectionHeading';
import { pains } from '../data/content';
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="paper-grain relative bg-shell py-16 sm:py-24" data-id="element-136" data-mp="2uy5m4yt3mvy0">
      <Container narrow className="relative" data-id="element-137" data-mp="2yz7nbl6kti2m">
        <SectionHeading id="pain-heading" eyebrow="Sound familiar?" title="This kit is for you if…" align="center" data-id="element-138" data-mp="2yxxogtrwg5ux" />

        <ul className="mx-auto mt-11 grid max-w-[760px] gap-3.5 sm:mt-14 sm:gap-4" data-id="element-139" data-mp="2q045ekj5b8pp">
          {pains.map((pain, index) => <li key={pain} className="flex items-start gap-4 rounded-card border border-hairline bg-white p-5 shadow-paper sm:gap-5 sm:p-6" data-id="element-140" data-mp="2bbr3l6xdmvna" data-mpi={index}>
              <span aria-hidden="true" className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-alertSoft font-display text-[13px] font-extrabold tabular-nums text-[#B91C1C]" data-id="element-141" data-mp="22at14t2l6w6t">
                {String(index + 1).padStart(2, '0')}
              </span>
              <p className="text-[17px] leading-[1.62] text-inkSoft sm:text-[18px]" data-id="element-142" data-mp="3nl5tiily4kug">{pain}</p>
            </li>)}
        </ul>
      </Container>
    </section>;
}